import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ISupplementCategories } from 'app/shared/model/supplement-categories.model';
import { getEntities as getSupplementCategories } from 'app/entities/supplement-categories/supplement-categories.reducer';
import { ISupplements } from 'app/shared/model/supplements.model';
import { getEntity, updateEntity, createEntity, reset } from './supplements.reducer';

export const SupplementsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const supplementCategories = useAppSelector(state => state.supplementCategories.entities);
  const supplementsEntity = useAppSelector(state => state.supplements.entity);
  const loading = useAppSelector(state => state.supplements.loading);
  const updating = useAppSelector(state => state.supplements.updating);
  const updateSuccess = useAppSelector(state => state.supplements.updateSuccess);

  const handleClose = () => {
    navigate('/supplements' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSupplementCategories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }

    const entity = {
      ...supplementsEntity,
      ...values,
      category: supplementCategories.find(it => it.id.toString() === values.category.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...supplementsEntity,
          category: supplementsEntity?.category?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fitengineerBackendV2App.supplements.home.createOrEditLabel" data-cy="SupplementsCreateUpdateHeading">
            <Translate contentKey="fitengineerBackendV2App.supplements.home.createOrEditLabel">Create or edit a Supplements</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="supplements-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.name')}
                id="supplements-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.quantity')}
                id="supplements-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.supplements.image')}
                id="supplements-image"
                name="image"
                data-cy="image"
                isImage
                accept="image/*"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.flavour')}
                id="supplements-flavour"
                name="flavour"
                data-cy="flavour"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.suitedFor')}
                id="supplements-suitedFor"
                name="suitedFor"
                data-cy="suitedFor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.description')}
                id="supplements-description"
                name="description"
                data-cy="description"
                type="textarea"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.supplements.image2')}
                id="supplements-image2"
                name="image2"
                data-cy="image2"
                isImage
                accept="image/*"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.supplements.image3')}
                id="supplements-image3"
                name="image3"
                data-cy="image3"
                isImage
                accept="image/*"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.isAvailable')}
                id="supplements-isAvailable"
                name="isAvailable"
                data-cy="isAvailable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.supplements.price')}
                id="supplements-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="supplements-category"
                name="category"
                data-cy="category"
                label={translate('fitengineerBackendV2App.supplements.category')}
                type="select"
                required
              >
                <option value="" key="0" />
                {supplementCategories
                  ? supplementCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.category}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/supplements" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SupplementsUpdate;
